export const connectorLocalStorageKey = "connectorIdv2";
export const walletLocalStorageKey = "wallet";
